<template>
  <div class="home-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">{{ $t('home.heroTitle') }}</h1>
        <p class="hero-subtitle">
          {{ $t('home.heroSubtitle1') }}<br>
          {{ $t('home.heroSubtitle2') }}
        </p>
        <div class="hero-actions">
          <el-button type="primary" size="large" round class="start-btn" @click="$router.push('/parser')">
            <el-icon class="el-icon--left"><VideoPlay /></el-icon>
            {{ $t('home.startCreation') }}
          </el-button>
          <el-button size="large" round class="learn-btn" plain @click="$router.push('/search')">
            <el-icon class="el-icon--left"><InfoFilled /></el-icon>
            探索爆款灵感
          </el-button>
        </div>
      </div>
    </section>

    <!-- 游客体验模式下醒目 Banner 提示条 -->
    <div class="guest-banner-wrapper" style="max-width: 1200px; margin: 16px auto -10px; padding: 0 20px;">
      <div class="guest-banner" style="background: linear-gradient(90deg, #f5f3ff 0%, #eef2ff 100%); border: 1px solid #ddd6fe; border-radius: 12px; padding: 12px 20px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; font-size: 13.5px; color: #5b21b6; font-weight: 500;">
          <span style="font-size: 18px;">💡</span>
          <span>当前为<strong>游客体验模式</strong>，免费试用基础功能。注册登录后即可一键解锁 4K 无损解析、AI 导演大模型二创与云端项目保存。</span>
        </div>
        <el-button type="primary" size="small" round class="btn-primary-purple" @click="$emit('open-login')">
          免费注册 / 登录账号
        </el-button>
      </div>
    </div>

    <!-- 创作者个人数据看板 (统一纯白 + 边框 #e5e7eb + 30px 品牌紫数字 + Sparkline 趋势图) -->
    <section class="metrics-dashboard-section" style="max-width: 1200px; margin: 30px auto 40px; padding: 0 20px;">
      <div class="metrics-grid" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;">
        <!-- 卡片 1 -->
        <div class="metric-card">
          <div class="metric-header">
            <div class="metric-icon-box">📹</div>
            <div class="metric-title-group">
              <span class="metric-label">本月视频解析量</span>
              <div class="metric-value-row">
                <span class="metric-number">38</span>
                <span class="metric-badge green">+12% 较上周</span>
              </div>
            </div>
          </div>
          <!-- Sparkline 迷你折线图 -->
          <svg class="sparkline-svg" viewBox="0 0 100 25">
            <path d="M0 20 L20 15 L40 18 L60 8 L80 12 L100 3" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" />
            <path d="M0 20 L20 15 L40 18 L60 8 L80 12 L100 3 L100 25 L0 25 Z" fill="rgba(124, 58, 237, 0.08)" />
          </svg>
        </div>

        <!-- 卡片 2 -->
        <div class="metric-card">
          <div class="metric-header">
            <div class="metric-icon-box">✨</div>
            <div class="metric-title-group">
              <span class="metric-label">字幕 / 水印去除</span>
              <div class="metric-value-row">
                <span class="metric-number">14</span>
                <span class="metric-badge green">已完成渲染</span>
              </div>
            </div>
          </div>
          <!-- Sparkline 迷你折线图 -->
          <svg class="sparkline-svg" viewBox="0 0 100 25">
            <path d="M0 18 L20 12 L40 14 L60 6 L80 9 L100 2" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" />
            <path d="M0 18 L20 12 L40 14 L60 6 L80 9 L100 2 L100 25 L0 25 Z" fill="rgba(16, 185, 129, 0.08)" />
          </svg>
        </div>

        <!-- 卡片 3 -->
        <div class="metric-card">
          <div class="metric-header">
            <div class="metric-icon-box">🤖</div>
            <div class="metric-title-group">
              <span class="metric-label">AI 导演改写脚本</span>
              <div class="metric-value-row">
                <span class="metric-number">26</span>
                <span class="metric-badge blue">大模型驱动</span>
              </div>
            </div>
          </div>
          <!-- Sparkline 迷你折线图 -->
          <svg class="sparkline-svg" viewBox="0 0 100 25">
            <path d="M0 22 L20 16 L40 10 L60 14 L80 7 L100 4" fill="none" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" />
            <path d="M0 22 L20 16 L40 10 L60 14 L80 7 L100 4 L100 25 L0 25 Z" fill="rgba(59, 130, 246, 0.08)" />
          </svg>
        </div>

        <!-- 卡片 4 -->
        <div class="metric-card">
          <div class="metric-header">
            <div class="metric-icon-box">⏱</div>
            <div class="metric-title-group">
              <span class="metric-label">累计节省创作时间</span>
              <div class="metric-value-row">
                <span class="metric-number">12.5 <span class="unit">小时</span></span>
                <span class="metric-badge purple">提效 4.5x</span>
              </div>
            </div>
          </div>
          <!-- Sparkline 迷你折线图 -->
          <svg class="sparkline-svg" viewBox="0 0 100 25">
            <path d="M0 19 L20 17 L40 11 L60 13 L80 5 L100 1" fill="none" stroke="#ea580c" stroke-width="2" stroke-linecap="round" />
            <path d="M0 19 L20 17 L40 11 L60 13 L80 5 L100 1 L100 25 L0 25 Z" fill="rgba(234, 88, 12, 0.08)" />
          </svg>
        </div>
      </div>
    </section>

    <!-- 功能 Launchpad 快速入口 (从静态展示改造为快捷交互卡片) -->
    <section class="launchpad-section" style="max-width: 1200px; margin: 0 auto 50px; padding: 0 20px;">
      <div class="section-header" style="text-align: center; margin-bottom: 24px;">
        <h2 style="font-size: 22px; color: #0f172a; margin-bottom: 6px;">⚡ 创作工具箱直达</h2>
        <p style="font-size: 14px; color: #64748b;">点击下方功能卡片，立即开启高效率 AI 短视频制作流</p>
      </div>

      <div class="launchpad-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px;">
        <!-- 入口 1 -->
        <div class="launchpad-card" @click="$router.push('/parser')">
          <div class="launchpad-icon purple">📹</div>
          <h3>多平台视频解析</h3>
          <p>支持 20+ 平台 4K/1080P 高清无水印视频与音频一键抓取</p>
          <div class="launchpad-action">立即使用 ➔</div>
        </div>

        <!-- 入口 2 -->
        <div class="launchpad-card" @click="$router.push('/subtitle-remover')">
          <div class="launchpad-icon green">✂️</div>
          <h3>智能去字幕与水印</h3>
          <p>基于 LAMA AI 模型快速擦除硬字幕与文字水印，保持原画质</p>
          <div class="launchpad-action">立即使用 ➔</div>
        </div>

        <!-- 入口 3 -->
        <div class="launchpad-card" @click="$router.push('/director')">
          <div class="launchpad-icon blue">🤖</div>
          <h3>AI 导演文案改写</h3>
          <p>接入大模型自动拆解爆款视频分镜，一键重写优质二创剧本</p>
          <div class="launchpad-action">立即使用 ➔</div>
        </div>

        <!-- 入口 4 -->
        <div class="launchpad-card" @click="$router.push('/search')">
          <div class="launchpad-icon amber">🔍</div>
          <h3>全网爆款灵感库</h3>
          <p>实时检索热门视频及评论数据，自带 0-100 AI 爆款评分</p>
          <div class="launchpad-action">立即使用 ➔</div>
        </div>
      </div>
    </section>

    <!-- Video Gallery -->
    <section class="gallery-section">
      <div class="section-header">
        <h2>{{ $t('home.galleryTitle') }}</h2>
        <p>{{ $t('home.gallerySub') }}</p>
      </div>
      
      <div class="video-grid">
        <div v-for="(video, index) in computedVideoTemplates" :key="index" class="video-card">
          <div class="card-thumbnail">
            <img :src="video.cover" :alt="video.title" loading="lazy" />
            <div class="video-duration">{{ video.duration }}</div>
            <div class="video-overlay">
              <el-button circle type="primary" size="large">
                <el-icon><VideoPlay /></el-icon>
              </el-button>
            </div>
            <!-- 难度分级徽章 -->
            <div class="difficulty-badge" :class="getDifficultyClass(index)">
              {{ index % 3 === 0 ? '🟢 简单拍' : index % 3 === 1 ? '🔵 进阶拍' : '🟣 挑战拍' }}
            </div>
          </div>
          
          <div class="card-content">
            <h3 class="video-title">{{ video.title }}</h3>
            <div class="video-tags">
              <el-tag size="small" effect="plain" v-for="tag in video.tags" :key="tag">{{ tag }}</el-tag>
            </div>
            
            <div class="video-meta">
              <div class="meta-label">{{ $t('home.shootingInstructions') }}</div>
              <ul class="meta-list">
                <li v-for="(step, idx) in video.steps" :key="idx">{{ idx + 1 }}. {{ step }}</li>
              </ul>
            </div>
            
            <div class="card-footer">
              <el-button type="primary" class="btn-primary-purple" size="small" @click="$router.push('/parser')">一键套用模板</el-button>
              <span class="likes-count">{{ video.likes }} {{ $t('home.likesDesc') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Video Gallery -->
    <section class="gallery-section">
      <div class="section-header">
        <h2>{{ $t('home.galleryTitle') }}</h2>
        <p>{{ $t('home.gallerySub') }}</p>
      </div>
      
      <div class="video-grid">
        <div v-for="(video, index) in computedVideoTemplates" :key="index" class="video-card">
          <div class="card-thumbnail">
            <img :src="video.cover" :alt="video.title" loading="lazy" />
            <div class="video-duration">{{ video.duration }}</div>
            <div class="video-overlay">
              <el-button circle type="primary" size="large">
                <el-icon><VideoPlay /></el-icon>
              </el-button>
            </div>
            <div class="video-badge" :class="video.badgeType">{{ video.badgeText }}</div>
          </div>
          
          <div class="card-content">
            <h3 class="video-title">{{ video.title }}</h3>
            <div class="video-tags">
              <el-tag size="small" effect="plain" v-for="tag in video.tags" :key="tag">{{ tag }}</el-tag>
            </div>
            
            <div class="video-meta">
              <div class="meta-label">{{ $t('home.shootingInstructions') }}</div>
              <ul class="meta-list">
                <li v-for="(step, idx) in video.steps" :key="idx">{{ idx + 1 }}. {{ step }}</li>
              </ul>
            </div>
            
            <div class="card-footer">
              <el-button type="success" class="use-btn" @click="$router.push('/parser')">{{ $t('home.useTemplate') }}</el-button>
              <span class="likes-count">{{ video.likes }} {{ $t('home.likesDesc') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
// Icons are globally registered in main.ts
const { t } = useI18n()

const getDifficultyClass = (index: number) => {
  if (index % 3 === 0) return 'diff-easy'
  if (index % 3 === 1) return 'diff-medium'
  return 'diff-hard'
}

const computedVideoTemplates = computed(() => [
  {
    title: "看看开业半个月的餐饮店营业实况",
    cover: "https://images.unsplash.com/photo-1552566626-52f8b828add9?q=80&w=600&auto=format&fit=crop",
    duration: "01:21",
    badgeText: t('home.badgeAdvance'),
    badgeType: "badge-orange",
    tags: ["2个场景", "经营日常", "餐饮人"],
    steps: ["夜访餐厅报道", "品牌宣传标语"],
    likes: "1033"
  },
  {
    title: "遇到这样的顾客，真是哭笑不得",
    cover: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=600&auto=format&fit=crop",
    duration: "00:13",
    badgeText: t('home.badgeSimple'),
    badgeType: "badge-yellow",
    tags: ["1个场景", "顾客服务", "口播视频"],
    steps: ["餐桌争议", "反转结局"],
    likes: "2.13W"
  },
  {
    title: "微笑服务 #湘南美食 #餐饮搞笑",
    cover: "https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=600&auto=format&fit=crop",
    duration: "00:24",
    badgeText: t('home.badgeSimple'),
    badgeType: "badge-yellow",
    tags: ["2个场景", "顾客服务"],
    steps: ["餐厅服务场景", "黑色背景图形"],
    likes: "432"
  },
  {
    title: "火锅店一年关30万家 #餐饮创业",
    cover: "https://images.unsplash.com/photo-1550966871-3ed3c6221741?q=80&w=600&auto=format&fit=crop",
    duration: "00:55",
    badgeText: t('home.badgeSimple'),
    badgeType: "badge-yellow",
    tags: ["1个场景", "创业开店", "口播视频"],
    steps: ["火锅店探访"],
    likes: "498"
  },
  {
    title: "山东济南铜锅涮羊肉，鑫龙火锅！",
    cover: "https://images.unsplash.com/photo-1542332213-31f87348057f?q=80&w=600&auto=format&fit=crop",
    duration: "04:57",
    badgeText: t('home.badgeChallenge'),
    badgeType: "badge-red",
    tags: ["9个场景", "食材特色"],
    steps: ["餐厅外介绍用餐", "室内讲述与分享", "餐厅服务与环境"],
    likes: "522"
  },
  {
    title: "在海边 在献县，在茫茫人海之中",
    cover: "https://images.unsplash.com/photo-1516062423079-7ca13cdc7f5a?q=80&w=600&auto=format&fit=crop",
    duration: "00:05",
    badgeText: t('home.badgeSimple'),
    badgeType: "badge-yellow",
    tags: ["1个场景", "营销宣传", "口播视频"],
    steps: ["夜晚街头自拍"],
    likes: "846"
  }
])

</script>

<style scoped>
.home-page {
  background-color: #fff;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  padding: 80px 20px;
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  color: white;
  padding: 70px 20px 80px;
  text-align: center;
  border-radius: 0 0 24px 24px; /* 柔和圆弧缓冲，消解切割刻板感 */
  box-shadow: 0 10px 25px -5px rgba(124, 58, 237, 0.15);
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.hero-title {
  font-size: 42px;
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.5px;
}

.hero-subtitle {
  font-size: 17px;
  line-height: 1.6;
  opacity: 0.92;
  margin-bottom: 36px;
}

/* 创作者 2x2 数据看板样式 */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

@media (max-width: 768px) {
  .metrics-grid {
    grid-template-columns: 1fr;
  }
}

.metric-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 22px 24px 14px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
  position: relative;
  overflow: hidden;
  transition: all 200ms ease;
}

.metric-card:hover {
  box-shadow: 0 10px 20px -5px rgba(124, 58, 237, 0.08);
  border-color: #ddd6fe;
}

.metric-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.metric-icon-box {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #f5f3ff;
  color: #7c3aed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.metric-title-group {
  flex: 1;
}

.metric-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}

.metric-value-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
}

.metric-number {
  font-size: 30px;
  font-weight: 800;
  color: #7c3aed;
  letter-spacing: -0.5px;
}

.metric-number .unit {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
}

.metric-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
}

.metric-badge.green { background: #dcfce7; color: #15803d; }
.metric-badge.blue { background: #dbeafe; color: #1d4ed8; }
.metric-badge.purple { background: #f3e8ff; color: #7e22ce; }

.sparkline-svg {
  width: 100%;
  height: 28px;
  margin-top: 10px;
  display: block;
}

/* Launchpad 快速入口工具箱 */
.launchpad-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px 20px;
  cursor: pointer;
  transition: all 180ms ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.launchpad-card:hover {
  transform: translateY(-4px);
  border-color: #a78bfa;
  box-shadow: 0 12px 24px -6px rgba(124, 58, 237, 0.12);
}

.launchpad-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin-bottom: 16px;
}

.launchpad-icon.purple { background: #f5f3ff; }
.launchpad-icon.green { background: #ecfdf5; }
.launchpad-icon.blue { background: #eff6ff; }
.launchpad-icon.amber { background: #fffbeb; }

.launchpad-card h3 {
  font-size: 17px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.launchpad-card p {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 16px;
}

.launchpad-action {
  font-size: 13px;
  font-weight: 600;
  color: #7c3aed;
}

.features-section {
  padding: 80px 20px;
  background-color: #f9fafb;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.section-header p {
  color: #666;
  font-size: 16px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  border: 1px solid #eee;
}

.feature-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
}

.feature-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  font-size: 32px;
}

.icon-purple { background: #f3e8ff; color: #9333ea; }
.icon-blue { background: #e0f2fe; color: #0284c7; }
.icon-orange { background: #ffedd5; color: #ea580c; }
.icon-green { background: #dcfce7; color: #16a34a; }

.feature-item h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #1a1a1a;
}

.feature-item p {
  color: #666;
  line-height: 1.6;
  font-size: 14px;
}

/* Gallery Section */
.gallery-section {
  padding: 80px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
}

.video-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eee;
  transition: all 0.3s;
}

.video-card:hover {
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
  transform: translateY(-5px);
}

.card-thumbnail {
  position: relative;
  height: 180px;
  overflow: hidden;
}

.card-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.video-card:hover .card-thumbnail img {
  transform: scale(1.05);
}

.video-duration {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.video-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: white;
}

.badge-orange { background: #f97316; }
.badge-yellow { background: #eab308; }
.badge-red { background: #ef4444; }

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.video-card:hover .video-overlay {
  opacity: 1;
}

.card-content {
  padding: 20px;
}

.video-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  line-height: 1.4;
  height: 44px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.video-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.video-meta {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.meta-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.meta-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: #555;
}

.meta-list li {
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.use-btn {
  background-color: #8bc34a; /* Greenish color from image */
  border-color: #8bc34a;
  font-weight: 600;
}

.use-btn:hover {
  background-color: #7cb342;
  border-color: #7cb342;
}

.likes-count {
  font-size: 12px;
  color: #999;
}
</style>
